interface PlayIconProps {
  className?: string;
  color?: string;
  size?: "base" | "xs" | "sm" | "md" | "lg" | "xl";
}

export const PlayIcon = ({
  className = "",
  color = "currentColor",
  size = "md",
}: PlayIconProps) => {
  const sizeClasses = {
    base: "w-5 h-5",
    xs: "w-4 h-4",
    sm: "w-5 h-5",
    md: "w-6 h-6",
    lg: "w-7 h-7",
    xl: "w-9 h-10",
  };

  return (
    <div className="icon play-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox=" 0 0 24 24"
        fill={color}
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        <path d="M3.36.19c.75,0,1.5.43,2.25.9l15.65,9.32c1.31.76,1.31,2.43,0,3.2l-15.65,9.32c-.75.47-1.5.88-2.25.88-1.44,0-1.6-1.19-1.6-1.81V2.02c0-.63.16-1.83,1.6-1.83Z" />
      </svg>
    </div>
  );
};
export default PlayIcon;
